module.exports = __webpack_public_path__ + "img/lens.fd5bbac7.svg";